import { render, staticRenderFns } from "./ModuleRole.vue?vue&type=template&id=330f5f42&scoped=true"
import script from "./ModuleRole.vue?vue&type=script&lang=js"
export * from "./ModuleRole.vue?vue&type=script&lang=js"
import style0 from "./ModuleRole.vue?vue&type=style&index=0&id=330f5f42&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "330f5f42",
  null
  
)

export default component.exports